import {useEffect, useRef, useState} from "react";
import "./_interactive-video.scss";

export default function InteractiveVideo({onclick, play}) {
    const videoRef = useRef();
    const videoWrapperRef = useRef()
    const overlayRef = useRef();

    const [overlayVisible, setOverlayVisible] = useState(false);
    const [overlayX, setOverlayX] = useState(0);
    const [overlayY, setOverlayY] = useState(0);
    const [overlayWidth, setOverlayWidth] = useState(0);
    const [overlayHeight, setOverlayHeight] = useState(0);

    const [fields, setFields] = useState([
//        {x0: 42.83, y0: 8.37, x1: 54.98, y1: 21.12},
        {x0: 52.59, y0: 21.51, x1: 64.14, y1: 31.67},
        {x0: 36.45, y0: 24.3, x1: 52.59, y1: 40.64},
        {x0: 52.39, y0: 32.07, x1: 69.52, y1: 51.79},
        {x0: 30.28, y0: 40.84, x1: 52.59, y1: 63.35},
        {x0: 16.93, y0: 56.37, x1: 30.28, y1: 67.93},
        {x0: 52.79, y0: 52.59, x1: 69.72, y1: 69.32},
        {x0: 69.72, y0: 63.75, x1: 81.47, y1: 75.9},
        {x0: 11.16, y0: 70.12, x1: 30.88, y1: 90.24},
        {x0: 30.48, y0: 64.74, x1: 47.21, y1: 80.88},
        {x0: 47.21, y0: 69.72, x1: 69.12, y1: 95.42},
        {x0: 31.08, y0: 81.27, x1: 46.02, y1: 94.62},
        {x0: 69.12, y0: 76.1, x1: 88.25, y1: 96.41},
        {x0: 43.09, y0: 7.15, x1: 55.77, y1: 21.63}
]);

    const nums = [
    /*1*/    [{time: 0, number: 2}, {time: 0.37072, number: 7}, {time: 1.080963, number: 12}, {time: 1.848381, number: 6}, {time: 2.572035, number: 9}, {time: 3.102282, number: 6}, {time: 3.818877, number: 2}],
    /*2*/    [{time: 0, number: 9}, {time: 0.479141, number: 1}, {time: 1.094516, number: 3}, {time: 1.936614, number: 1}, {time: 2.597587, number: 3}, {time: 3.227220, number: 5}, {time: 3.806454, number: 9}],
    /*3*/    [{time: 0, number: 6}, {time: 0.467989, number: 12}, {time: 1.19729, number: 9}, {time: 1.921367, number: 10}, {time: 2.656456, number: 6}, {time: 2.656456, number: 12}, {time: 3.813795, number: 6}],
    /*4*/    [{time: 0, number: 12}, {time: 0.535187, number: 5}, {time: 1.117386, number: 4}, {time: 2.0288, number: 2}, {time: 2.639092, number: 11}, {time: 3.129104, number: 9} , {time: 3.859394, number: 12}],
    /*5*/    [{time: 0, number: 11}, {time: 0.242394, number: 6}, {time: 1.062046, number: 8}, {time: 1.7929, number: 12}, {time: 2.521212, number: 7}, {time: 3.107929, number: 1}, {time: 3.819018, number: 11}],
    /*6*/    [{time: 0, number: 1}, {time: 0.328086, number: 4}, {time: 1.070234, number: 11}, {time: 1.85000, number: 4}, {time: 2.570058, number: 5}, {time: 3.207738, number: 7}, {time: 3.803489, number: 1}],
    /*7*/    [{time: 0, number: 10}, {time: 0.385826, number: 11}, {time: 1.036635, number: 2}, {time: 1.861086, number: 8}, {time: 2.533636, number: 6}, {time: 3.133481, number: 11}, {time: 3.839206, number: 10}],
    /*8*/    [{time: 0, number: 5}, {time: 0.514152, number: 2}, {time: 1.072634, number: 7}, {time: 2.608881, number: 2}, {time: 3.825653, number: 25}],
    /*9*/    [{time: 0, number: 4}, {time: 0.449072, number: 9}, {time: 1.144632, number: 1}, {time: 1.945084, number: 9}, {time: 2.660974, number: 10}, {time: 3.833983, number: 4}],
    /*10*/   [{time: 0, number: 8}, {time: 0.474483, number: 10}, {time: 1.244442, number: 5}, {time: 2.648127, number: 12}, {time: 3.245714, number: 4}, {time: 3.80236, number: 8}],
    /*11*/   [{time: 0, number: 7}, {time: 0.316369, number: 3}, {time: 1.041435, number: 10}, {time: 1.843863, number: 11}, {time: 2.504272, number: 4}, {time: 3.132916, number: 3}, {time: 3.846265, number: 7}],
    /*12*/   [{time: 0, number: 3}, {time: 0.426625, number: 8}, {time: 1.017717, number: 6}, {time: 1.98306, number: 3}, {time: 2.544788, number: 1}, {time: 3.331547, number: 8}, {time: 3.846829, number: 3}],
    /*13*/   [{time: 0, number: 13}],
    ]

    const [currentTime, setCurrentTime] = useState(0);

    function normalize(f) { return Math.round(f * 10000) / 100}

    useEffect(() => {
        if (videoRef.current) {
            if (!play) {
                videoRef.current.pause();
                videoWrapperRef.current.classList.add('paused');
            }
            else {
                videoRef.current.play();
                videoWrapperRef.current.classList.remove('paused');
            }
        }
    }, [play]);


    useEffect( () => {
        if (!videoRef.current) return;
        videoRef.current.addEventListener('ended', handleVideoEnded);
        let startX, startY;
        let currentX, currentY;
        let width, height;
        // videoRef.current.addEventListener('mousedown', handleMouseDown);
        // videoRef.current.addEventListener('mousemove', handleMouseMove);
        // videoRef.current.addEventListener('mouseup', handleMouseUp);
        videoRef.current.addEventListener('click', handleMouseClick)
        // videoRef.current.addEventListener('timeupdate', handleTimeUpdate)

        function handleVideoEnded(e) {
            e.target.currentTime = 0;
            e.target.play();
        }
        // function handleMouseDown(e) {
        //     startX = e.offsetX / e.target.offsetWidth;
        //     startY = e.offsetY / e.target.offsetHeight;
        //     setOverlayVisible(true);
        //     setOverlayX(startX*100 + '%');
        //     setOverlayY(startY*100 + '%');
        //     setOverlayHeight(0);
        //     setOverlayWidth(0)
        // }
        // function handleMouseMove(e) {
        //     currentX = e.offsetX / e.target.offsetWidth;
        //     currentY = e.offsetY / e.target.offsetHeight;
        //     width = currentX - startX;
        //     height = currentY - startY;
        //
        //     setOverlayWidth(width*100 + '%');
        //     setOverlayHeight(height*100 + '%');
        // }
        // function handleMouseUp(e) {
        //     setOverlayVisible(false);
        //     let data = ('x: ' + normalize(startX)+ ', ') +
        //         ('y: ' + normalize(startY) + ', ') +
        //         ('width: ' + normalize(width) + ', ') +
        //         ('height: ' + normalize(height));
        //     // debugRef.current.innerText = data;
        //
        //     if (width>0.05 && height>.05) {
        //         setFields( fields => {
        //             return fields.concat([{x0: normalize(startX), y0: normalize(startY), x1: normalize(currentX), y1: normalize(currentY)}])
        //         })
        //     }
        //
        // }
        function handleMouseClick(e) {
            let x = normalize(e.offsetX / e.target.offsetWidth);
            let y = normalize(e.offsetY / e.target.offsetHeight);
            let time = e.target.currentTime;

            for(let i in fields) {
                let fld = fields[i];
                if ((fld.x0 <= x && x <= fld.x1) && (fld.y0 <= y && y <= fld.y1)) {
                    console.log('Click on '+ (parseInt(i)+1) + ' field in ' + time + ' s');
                    const timeSpans = nums[i];
                    if (Array.isArray(timeSpans)) {
                        for (let index in timeSpans) {
                            index = parseInt(index);
                            if (time > timeSpans[index].time && (index >= timeSpans.length-1 || time < timeSpans[1+index].time)) {
                                // console.log('WYLOSOWANO NUMER '+ timeSpans[index].number);
                                onclick(timeSpans[index].number);
                                // videoRef.current.pause();
                                // videoWrapperRef.current.classList.add('paused');
                                break;
                            }
                        }
                    }
                }
            }

        }

        // function handleTimeUpdate(e) {
        //     setCurrentTime(e.target.currentTime);
        // }

        return () => {
            videoRef.current.removeEventListener('ended', handleVideoEnded);
            // videoRef.current.removeEventListener('mousedown', handleMouseDown);
            // videoRef.current.removeEventListener('mousemove',handleMouseMove);
            // videoRef.current.removeEventListener('mouseup',handleMouseUp);
            videoRef.current.removeEventListener('click',handleMouseClick);
            // videoRef.current.removeEventListener('timeupdate', handleTimeUpdate)
        }

    }, []);

    // function DebuggerFrame() {
    //     return <div>
    //         <div>CurrentTime: {currentTime}</div>
    //         <ol style={{fontSize: '12px', fontFamily: 'monospace'}}>
    //             {fields.map( fld => (
    //                 <li>
    //                     x0: {fld.x0}, y0: {fld.y0}, x1: {fld.x1}, y1: {fld.y1}
    //                 </li>
    //             ))}
    //         </ol>
    //     </div>
    // }
    // function VisualizeFields() {
    //     return <>
    //         {fields.map(fld => (
    //             <div className="overlay" style={{
    //                 left: fld.x0+'%',
    //                 top: fld.y0+'%',
    //                 width: (fld.x1-fld.x0)+'%',
    //                 height: (fld.y1-fld.y0)+'%'
    //             }}></div>
    //         ))}
    //         <div className="overlay" ref={overlayRef} style={{
    //             display: overlayVisible ? 'block' : 'none',
    //             top: overlayY,
    //             left: overlayX,
    //             width: overlayWidth,
    //             height: overlayHeight
    //         }}></div>
    //     </>
    // }

    return <div className="interactive-video">
        <div className="video-wrapper" ref={videoWrapperRef}>
            <video ref={videoRef} src="./assets/video/XmasTreeLottery24_241212_ss_v06.mp4" muted playsInline={true} autoPlay></video>
            {/*{VisualizeFields()}*/}
        </div>
        {/*{DebuggerFrame(currentTime, fields)}*/}
    </div>
}
